var map = {
	"./Ignite-Help-Support-SampleData.json": [
		92994,
		"src_assets_json_Ignite-Help-Support-SampleData_json"
	],
	"./ignite.json": [
		36517,
		"src_assets_json_ignite_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 59450;
module.exports = webpackAsyncContext;